import { render, staticRenderFns } from "./ChangePrestage.vue?vue&type=template&id=23cc2bca&"
import script from "./ChangePrestage.vue?vue&type=script&lang=js&"
export * from "./ChangePrestage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports